import './App.css';
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Snackbar } from '@mui/material';
import { AppBar, Box, Toolbar } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import AppTopBar from './components/common/app-top-bar';
import LoginOtp from './components/login-otp';

import { AppHelper } from './AppHelper';
import SpaCheck from './components/common/spa-check';
import { useUserContext } from './contexts/context-user';

export default function App() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [msgBox, setMsgBox] = React.useState({
    open: false, vertical: 'top', horizontal:'center', msg: ''
  });
  const [userAgent, setUserAgent] = useState('-');
  const { getUser } = useUserContext();
  const { inviteId } = useParams();

  useEffect(() => {
    detectBrowser();
    if(!AppHelper.isEmptyString(inviteId)){
      AppHelper.cacheInviteIdSet(inviteId);
    }
    else{
      AppHelper.cacheInviteIdSet();
    }
  }, []);
  // Called by the email-OTP form once the code is verified: exchange the single-use ticket for a session.
  const siteLogin = async(_email, _loginTicket)=>{
    setIsLoading(true);
    const _resUser = await AppHelper.apiPost('api/profile/login/', {email: _email, name: '', loginTicket: _loginTicket});

    setIsLoading(false);
    if(!_resUser || !_resUser.status){
      setMsgBox({...msgBox, open: true, msg: (_resUser && _resUser.message) ? _resUser.message : 'ERROR: Failed to login.'});
      return;
    }

    const _resProfile = await AppHelper.apiPost('api/profile/get/', {token: _resUser.token})
    if(!_resUser.status){
      setMsgBox({...msgBox, open: true, msg: 'ERROR: Failed to load profile.'});
      return;
    }
    AppHelper.userCacheSet({
      token: _resUser.token, email: _email, name: _resProfile.data.name, grade: _resProfile.data.grade, 
      profileId:_resProfile.data.profileId, accountType: _resProfile.accountType, ownerId:_resProfile.ownerId,
      picture: _resProfile.avatarImage, countryCode: _resUser.countryCode, locale: _resUser.locale, 
    });
    getUser();
    console.log("oUser", {
      token: _resUser.token, email: _email, name: _resProfile.data.name, grade: _resProfile.data.grade, 
      profileId:_resProfile.data.profileId, accountType: _resProfile.accountType, ownerId:_resProfile.ownerId,
      picture: _resProfile.avatarImage, countryCode: _resUser.countryCode, locale: _resUser.locale, 
    })
    
    await tutorInviteAccept(_resProfile.data.profileId, _resUser.token, _email);

    if(_resUser.firstTime == 1)
      navigate('/home');
    else{
      navigate('/profile');
    }
  };
  const tutorInviteAccept = async(_profileId, argToken, argEmail)=>{
    var _inviteId = AppHelper.cacheInviteIdGet();
    if(AppHelper.isEmptyString(_inviteId))
      return;
    
    const _resInvite = await AppHelper.apiPost('api/tuiton/invite/get', {profileId:_profileId, inviteId:_inviteId, token:argToken });
    if(!_resInvite.status || !_resInvite.data){
      alert('Failed to accept the Invite. Failed to read the invite info!');
      return;
    }
    if(!_resInvite.data.email || _resInvite.data.email.toLowerCase() != argEmail.toLowerCase()){
      alert('Failed to accept the Invite. Failed to verify your email!');
      return;
    }
    const _resCenterUpdate = await AppHelper.apiPost('api/profile/center/update', {profileId:_profileId, inviteId:_inviteId });
    const _resAccept = await AppHelper.apiPost('api/tuiton/accept', {profileId:_profileId, inviteId:_inviteId });
    const _resAccType = await AppHelper.apiPost('api/account/updateAccountType', {token:argToken, accountType:'TEA' });
    var _userCache = AppHelper.userCacheGet();
    _userCache.accountType = 'TEA';
    const _arrAccess = _resInvite.data.accessRight.split(';')
      .filter(item => item) // Filter out empty strings
      .map(item => {
        const [key, value] = item.split(':'); // Split each part by colon
        return { key, value: Number(value) };  // Create object and convert value to number
      });
    for(var i=0;i<_arrAccess.length;i++){
      var _resAccess = await AppHelper.apiPost("api/access/update", {
        token: argToken,
        profileId: _profileId,
        grade: _arrAccess[i].key,
        access: _arrAccess[i].value
      });
    }
    AppHelper.userCacheSet(_userCache);
  }
  const detectBrowser = ()=>{
    var sBrowser, sUsrAg = navigator.userAgent;
    // The order matters here, and this may report false positives for unlisted browsers.

    if (sUsrAg.indexOf("Firefox") > -1) {
      sBrowser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
      sBrowser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
      sBrowser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
      sBrowser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
      sBrowser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
      sBrowser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      sBrowser = "unknown";
    }
    setUserAgent(sBrowser);
  };

  useEffect(()=>{
    const oUser = AppHelper.userCacheGet();
    if(oUser != null){
      loginUserGoHome(oUser);
    }
    else{
    }
  }, []);

  const loginUserGoHome = async (argUser)=>{
    await tutorInviteAccept(argUser.profileId, argUser.token, argUser.email);
  }


  return (
    <>
      <AppTopBar />
      <SpaCheck></SpaCheck>
      <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
        {isLoading?(
          <Box display='flex' alignItems='center' justifyContent='center' minHeight='100vh'>
            <CircularProgress />
          </Box>
        ):(
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="90vh"
            flexDirection='column'
          >
            <div>
              <img src='/logo-login.png?v=20231101' style={{maxWidth:'180px', marginTop:'-7rem', marginBottom:'1rem'}} />
            </div>
            <Box textAlign={'justify'} sx={{textAlignLast:'center'}} color={'#1b5e20'}>
              Welcome to Essay Ace, your journey to becoming a writing wizard starts here! Tailored for primary school students, our platform makes writing fun and learning easy. Through personalized feedback and creative suggestions, we aim to boost confidence and spark a love of writing. Dive into the adventure of words and watch your skills soar. Ready for the magic? Log in and let’s create wonders together!
            </Box>
            <LoginOtp onVerified={siteLogin} />
            <AppBar position="fixed" style={{ top: 'auto', bottom: 0, backgroundColor:'#fff', color:'#666', boxShadow:'none' }}>
              <Toolbar style={{textAlign:'center'}}>
                <div variant="body2" color="inherit" style={{width:'100%', fontSize:'0.9rem'}}>
                </div>
              </Toolbar>
            </AppBar>
          </Box>
        )}
      </Container>
      <Snackbar
        open={msgBox.open}
        autoHideDuration={6000}
        message={msgBox.msg}
        anchorOrigin={{ vertical:msgBox.vertical, horizontal:msgBox.horizontal }}
        onClose={() => setMsgBox({...msgBox, open: false})}
      />
    </>
  );
}
